import React, { useState } from "react";
import Reveal from "./Reveal";
import { views3d } from "../mock";

const SectionTitle = ({ children }) => (
  <div className="flex flex-col items-center">
    <h2 className="font-display text-neg-navy text-4xl sm:text-5xl text-center">{children}</h2>
    <span className="mt-5 h-px w-16 bg-neg-gold" />
  </div>
);

const Views3D = () => {
  const [active, setActive] = useState(views3d.tabs[0].id);
  const current = views3d.tabs.find((t) => t.id === active);

  return (
    <section id="views" className="bg-neg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <Reveal>
          <SectionTitle>{views3d.title}</SectionTitle>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {views3d.tabs.map((t) => (
              <button
                key={t.id}
                onClick={() => setActive(t.id)}
                className={`px-6 py-3 text-sm tracking-widest uppercase transition-all duration-300 border ${
                  active === t.id
                    ? "bg-neg-green text-neg-cream border-neg-green"
                    : "bg-transparent text-neg-navy/70 border-neg-navy/20 hover:border-neg-gold hover:text-neg-navy"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-10 overflow-hidden bg-white shadow-xl shadow-black/10">
            <img
              key={current.id}
              src={current.image}
              alt={current.label}
              className="w-full h-[340px] sm:h-[480px] lg:h-[620px] object-cover animate-fadein"
              loading="lazy"
            />
          </div>
          <p className="mt-6 text-center text-neg-navy/50 italic text-sm">{views3d.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Views3D;
